import { Button } from "@msuite/ui/button";
import { useDisclosure, useLoading } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment, responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { AddTeamModal } from "@/modals/organizations/add-team-modal";

export function OrganizationSettingsTeamsMenu() {
	/** Hooks */
	const { t } = useTranslation();
	const { refetch } = useDataTableContext();
	const disclosure = useDisclosure();
	const loader = useLoading();
	const { organization } = useAuth();

	/** Functions */
	async function handleOnSyncTeams() {
		try {
			loader.start();
			const orgId = organization.id;
			if (!orgId) throw new Error("Could not find orgId");
			const response = await client.organizations[":orgId"].teams.sync.$patch({ param: { orgId } });
			await responseHandler(response);
			await refetch?.();
		} catch (error) {
			console.error(error);
		} finally {
			loader.stop();
		}
	}

	/** Render */
	return (
		<Fragment>
			<Button
				variant="primary"
				icon={<Icon name="Plus" />}
				onClick={disclosure.onOpen}
			>
				{t("organization.add_team")}
			</Button>
			<Button
				icon={<Icon name="RefreshCcwDot" />}
				onClick={handleOnSyncTeams}
				isLoading={loader.isLoading}
			>
				{t("organization.sync_teams_with_personio")}
			</Button>
			{disclosure.isOpen && (
				<AddTeamModal
					onClose={disclosure.onClose}
					isOpen={disclosure.isOpen}
					onComplete={refetch}
				/>
			)}
		</Fragment>
	);
}
